import React from "react";
import { NameAndHub } from "../NameAndHub";
import { Row, Col } from "antd";

export function ViewPersonalAddress({ personalAddress }) {
  return (
    <>
      {" "}
      <div className="view-basic-details">
        <div className="view-details-header">
          <div className="view-details-header-text">Address Details</div>
        </div>
        {/* <div className="view-basic-details-contain">
        
        </div> */}
        <Row className="basic-details-view">
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Residential address line 1"}
                  hub={personalAddress.rAddress1}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"City"} hub={personalAddress?.city1} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Permanent address line 1"}
                  hub={personalAddress?.pAddress1}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"City"} hub={personalAddress?.city2} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Educational qualification"}
                  hub={personalAddress?.education}
                />
              </div>
            </div>
          </Col>

          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Residential address line 2"}
                  hub={personalAddress?.rAddress2}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"State"} hub={personalAddress?.state1} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Permanent address line 2"}
                  hub={personalAddress?.pAddress2}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"State"} hub={personalAddress?.state2} />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Marital Status"}
                  hub={personalAddress?.marital}
                />
              </div>
            </div>
          </Col>
          <Col lg={8}>
            <div className="basic-details-container">
              <div>
                <NameAndHub
                  name={"Cp in charge"}
                  hub={personalAddress?.cpInCharge}
                />
              </div>
            </div>
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"PIN code"} hub={personalAddress?.pincode1} />
              </div>
            </div>
            {/* <div className="basic-details-container">
              <div>
                <NameAndHub name={"State"} hub={personalAddress} />
              </div>
            </div> */}
            <div className="basic-details-container">
              <div>
                <NameAndHub name={"PIN code"} hub={personalAddress?.pincode2} />
              </div>
            </div>
            {/* <div className="basic-details-container">
              <div>
                <NameAndHub name={"State"} hub={personalAddress} />
              </div>
            </div> */}
            {personalAddress?.marriageDate !== "NaN-NaN-NaN" && (
              <div className="basic-details-container">
                <div>
                  <NameAndHub
                    name={"Marriage date"}
                    hub={personalAddress?.marriageDate}
                  />
                </div>
              </div>
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}
